<template>
  <section>
    <div class="w-100">
      <div class="w-75 mx-auto">
        <h2 class="text-center">Upcoming Events</h2>
        <p class="mt-3">
          Please be sure to review the rules and guidelines mentioned
          <router-link to="/events/rules">here</router-link>. Anyone who attend a hosted event, or
          posts a reply, constitutes as agreeing to the code of conduct, guidelines, and rules listed
        </p>
      </div>
      <EventCardList @refreshEvents="pullEvents" :events="pulledEvents"/>
      <v-row no-gutters class="mt-4">
        <div class="flex-fill"></div>
      </v-row>
    </div>
  </section>
</template>

<script>
import {mapActions, mapGetters} from 'vuex';
import EventCardList from './components/eventCardList';
import {functions} from '@/core/config/firebase.js';

export default {
  name: 'EventsDashboard',
  components: {
    EventCardList
  },
  data() {
    return {
      pulledEvents: {},
    }
  },
  watch: {
    getNextEvents(newValue) {
      this.pulledEvents = newValue;
    },
    async isHiddenEventsPulled() {
      this.pulledEvents = await this.getNextEvents;
    },
    async getEventChangeCount() {
      this.pulledEvents = await this.getNextEvents;
    }
  },
  computed: {
    ...mapGetters('events', ['getNextEvents', 'isHiddenEventsPulled', 'getEventChangeCount']),
    ...mapGetters('user', ['getCurrentUser']),
  },
  methods: {
    ...mapActions('events', ['pullNextEvents']),
    ...mapActions('user', ['waitForProfile']),
    async pullEvents() {
      let events = [];
      const userProfile = this.getCurrentUser;

      // Guest users cannot view hidden events, only pull visible ones
      if (userProfile) {
        events = await this.pullNextEvents(true);
      } else {
        events = await this.pullNextEvents(false);
      }

      this.pulledEvents = events;
    }
  },
  async mounted() {
    let userProfile = this.getCurrentUser;

    if (userProfile === 'verifying')
      await this.waitForProfile();

    this.pullEvents()
  }
}
</script>
<style>
.color-block {
  background-color: #EF5350;
  width: 300px;
  height: 300px;
}
</style>
